import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { FlexCenter } from '../../global/commonStyle';

interface Props {
  isImage?: boolean;
}

const Group = styled.div``;

const Container = styled.div`
  position: relative;
`;

const FileBlock = styled.div<{ isActive?: boolean }>`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: var(--space-0);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-card);
  border-radius: var(--border-radius-8);
  cursor: pointer;
  .active-dropdown {
    display: none;
  }
  &:hover {
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    box-shadow: var(--shadow-card-hover);
  }
  &:hover .active-dropdown {
    display: flex;
  }
  ${(props) =>
    props.isActive &&
    css`
      .active-dropdown {
        display: flex;
        border-radius: var(--border-radius-6);
        background-color: var(--neutral-secondary);
      }
    `}
  ${mobile_xl(css`
    .active-dropdown {
      display: flex;
    }
  `)}
`;

const Icon = styled.div<Props>`
  margin: auto;
  padding-block: var(--space-11);
  width: 60px;
  height: 60px;
  ${(props) =>
    props.isImage &&
    css`
      padding: var(--space-0);
      margin: unset;
      width: 100%;
      height: 106px;
    `}
  ${mobile_xl(css`
    width: 53px;
    height: 53px;
    padding-block: var(--space-8);
    ${FlexCenter}
    ${(props: Props) =>
      props.isImage &&
      css`
        padding: var(--space-0);
        margin: unset;
        width: 100%;
        height: 97px;
      `}
  `)}
`;

const FileContent = styled.div`
  border-top: 0.5px solid var(--border-primary);
  padding: var(--space-12);
  /* keep tooltip wrapper from growing past the card so end text still truncates */
  > div {
    max-width: 100%;
  }
  ${mobile_xl(css`
    padding: var(--space-14);
  `)}
`;

const Title = styled.h1`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${mobile_xl(css`
    color: var(--text-primary);
  `)}
`;

const Text = styled.p`
  ${Typography.body_sm}
  color: var(--text-secondary);
  margin: var(--space-1) var(--space-0) var(--space-0);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${mobile_xl(css`
    color: var(--text-secondary);
  `)}
`;
const MoreIcon = styled.div<Props>`
  display: flex;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

const Image = styled.div<Props>`
  position: relative;
  padding: var(--space-12) var(--space-16);
  ${(props) =>
    props.isImage &&
    css`
      padding: var(--space-0);
    `}
  ${mobile_xl(css`
    padding: var(--space-14);
    ${(props: Props) =>
      props.isImage &&
      css`
        padding: var(--space-0);
      `}
  `)}
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const ModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-12);
`;

const FileIcon = styled.div`
  position: absolute;
  cursor: pointer;
  width: 18px;
  height: 18px;
  .fillColor {
    fill: var(--text-tertiary);
  }
`;

export {
  Group,
  Container,
  FileBlock,
  Icon,
  FileContent,
  Title,
  Text,
  MoreIcon,
  Image,
  ModalContent,
  ModalForm,
  ModalButton,
  FileIcon
};
